export default function initSimpleMegaMenu() {
    // ==========================================================
    // MEGA MENUS SIMPLES
    // ==========================================================

    const simpleMegaMenus = document.querySelectorAll(".mega-menu-simple");

    simpleMegaMenus.forEach((megaMenu) => {
        const subMenu = megaMenu.querySelector(":scope > .sub-menu");

        const imageData = megaMenu.querySelector(":scope > a + .mega-menu__image-data");

        if (!subMenu || !imageData) {
            return;
        }

        const imageUrl = imageData.dataset.image;

        if (!imageUrl) {
            return;
        }

        const visual = document.createElement("div");

        visual.classList.add("mega-menu-simple__visual");

        const image = document.createElement("img");

        image.src = imageUrl;
        image.alt = "";
        image.loading = "lazy";

        visual.appendChild(image);
        subMenu.prepend(visual);
    });
}
